import Vue from 'vue';
import { VueMaskDirective } from 'v-mask';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import router from '@/router';
import store from '@/store';
import 'element-ui/lib/theme-chalk/index.css';

import App from './App.vue';

Vue.use(ElementUI, { locale });

Vue.directive('mask', VueMaskDirective);

Vue.config.productionTip = false;

store.dispatch('User/initCurrentUser').finally(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
}).catch(() => console.info('user login is required...'));
